import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useError } from "./ErrorContext";
import { useRef, useState } from "react";

export function ReactQueryProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { handleErrorAction } = useError();
  const errorHandlerRef = useRef(handleErrorAction);
  errorHandlerRef.current = handleErrorAction;

  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            retry: false,
            onError: (error) => errorHandlerRef.current(error as Error),
          },
          mutations: {
            onError: (error) => errorHandlerRef.current(error as Error),
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
